import React from 'react';
import Field from './Field';

/** Multi-line input (min-height 64px per spec). */
export default function Textarea({ label, className = '', fieldClassName = '', ...rest }) {
  return (
    <Field label={label} className={fieldClassName}>
      <textarea className={`ui-textarea ${className}`.trim()} {...rest} />
    </Field>
  );
}
